export default {"src":"/_next/static/media/twitterx.c53542d3.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};